module.exports = __webpack_public_path__ + "img/page-08.ad78eb1b.png";